import { Box } from 'src/components/Box';
import { Icon } from 'src/components/Icon';
import { CartItem as CartItemType } from 'src/models/cart/_types';
import { selectableItemTypes } from 'src/shared/constants/itemTypes';

interface SearchItem extends CartItemType {
  name: string;
  aliases?: string[];
  header?: string;
  type: string;
  image: string;
}

interface CartItemAvatarProps {
  item: CartItemType | SearchItem;
}

export const CartItemAvatar = ({ item }: CartItemAvatarProps) => {
  const type = selectableItemTypes?.find((t) => {
    if (item.itemType === t.modelName) {
      return true;
    }
    if ((item as SearchItem).type === t.value) {
      return true;
    }
  });

  const imageUrl = (item as SearchItem).image || item.item?.imageUrl;
  const typeIcon = type?.icon;

  return (
    <Box
      sx={{
        width: 60,
        height: 50,
        bgcolor: 'primary.50',
        border: '1px solid',
        borderColor: 'primary.100',
        borderRadius: 1,
        mr: 2,
        display: 'flex',
        flexShrink: 0,
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '0px',
          left: '0px',
          backgroundImage: `url(${imageUrl})`,
          backgroundSize: 'cover',
          width: '100%',
          height: '100%',
        }}
      ></Box>
      {typeIcon && <Icon sx={{ color: 'primary.dark' }} icon={typeIcon} />}
    </Box>
  );
};
